import BaseService from "./BaseService";
import { toast, Notification } from "components/ui";

const ApiService = {
  fetchData(param) {
    return new Promise((resolve, reject) => {
      BaseService(param)
        .then((response) => {
          resolve(response);

          
          const method = (param?.method || "get").toLowerCase();
          const isMutation = ["post", "put", "patch", "delete"].includes(method);

          if (
            isMutation &&
            (response?.data?.message || response?.data?.response) &&
            response?.data?.succeeded !== false
          ) {
            const message =
              typeof response?.data?.message === "string"
                ? response.data.message
                : typeof response?.data?.response === "string"
                ? response.data.response
                : "";

            const isSingleService = message
              .toLowerCase()
              .startsWith("single service") || message.toLowerCase().startsWith("service item added")

            if (!isSingleService) {
              toast.push(
                <Notification
                  title="Successfully Done"
                  type="success"
                  duration={2500}
                >
                  {message || "Operation completed successfully"}
                </Notification>,
                {
                  placement: "top-center",
                }
              );
            }
          }
        })
        .catch((errors) => {
          console.log(errors);
          const errorResponse = errors.response?.data;

          if (errorResponse) {
            const errorTitle = errorResponse.title || "Validation Error";

            // Extract the validation error details
            const validationErrors = errorResponse.errors;
            const errorMessages = validationErrors
              ? Object.entries(validationErrors)
                  .map(([messages]) => messages.join(", "))
                  .join(" | ")
              : "An unexpected error occurred.";

            toast.push(
              <Notification title={errorTitle} type="danger" duration={4000}>
                {errorMessages}
              </Notification>,
              {
                placement: "top-center",
              }
            );
          } else {
            // Default error message for unexpected issues
            toast.push(
              <Notification title={"Error"} type="danger" duration={4000}>
                {"An unexpected error occurred."}
              </Notification>,
              {
                placement: "top-center",
              }
            );
          }

          reject(errorResponse?.title || "An unexpected error occurred.");
        });
    });
  },
};

export default ApiService;
